export const environment = {
  production: true,
  homologation: false,
  development: false,

  name: 'prod',

  aws_account_id: 481653260748,

  cif_versao1_recuperacao:
    'https://canaisassistidosprc.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao1_seguros_pf:
    'https://plataformaatendimento.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_civics:
    'https://plataformaatendimento.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_civics_v2:
    'https://plataformaatendimento.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_pj:
    'https://canaisassistidosprc.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_pf:
    'https://canaisassistidosprc.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_npc:
    'https://engajamentocartoes.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao2_corretora:
    'https://usercorretorainst-prod.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao_2_gerentes_pf:
    'https://plataformaatendimento.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao_2_redes_pf:
    'https://userede.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  cif_versao_2_ibba:
    'https://plataformaatendimento.crm2.dynamics.com/webresources/Widget/msdyn_ciLibrary.js',
  esteiras_corretora: {
    bovespa: '/msft_esteiras(1fdf5f84-a18a-ec11-93b0-000d3a304f1b)',
    BMF: '/msft_esteiras(9a8f8bfd-9f8a-ec11-93b0-000d3a304f1b)',
    BTC: '/msft_esteiras(2da77749-9f8d-ec11-b400-000d3a339b12)',
    cadastro: '/msft_esteiras(c622e159-3248-ee11-be6f-000d3ac16f71)',
    custodia_margem: '/msft_esteiras(faad9f85-44a9-ed11-aad0-000d3a88fff5)',
    financeiro: '/msft_esteiras(9b166e61-9f8d-ec11-b400-000d3a339b12)',
    esteira_default: '/msft_esteiras(edaeb847-d516-f011-998a-002248d2ff17)',
    assunto: '/msft_assuntoscorretoras(020ced92-a209-f011-bae2-002248379c6d)',
    classificacao: '/msft_classificacaos(7ea68bc8-35da-ee11-904d-000d3a88e6e8)',
    contato_default: '546371f3-99ab-f011-bbd2-002248372f2a',
  },
  appClientId: '7f52e58b-330e-4989-9306-33e06816238a',

  charon: {
    isCrypt: true,
    entrypoint: 'https://apicd.cloud.itau.com.br/charon/dqjqrgr5',
    ID: 'dqjqrgr5',
  },

  openId: {
    callbackUrl: 'https://agent-iframe.cloud.itau.com.br/idp-callback',
    issuerUrl:
      'https://login.microsoftonline.com/591669a0-183f-49a5-98f4-9aa0d0b63d81/v2.0',
    refreshUrl:
      'https://login.microsoftonline.com/591669a0-183f-49a5-98f4-9aa0d0b63d81/oauth2/v2.0/token',
    scope:
      'openid profile email offline_access api://7f52e58b-330e-4989-9306-33e06816238a/PS7-agent-iframe',
  },

  datadogAppId: '6cdb68a8-a475-4aac-9fd4-51b405290870',
  dataDogExternalClientToken: 'pub98e36448f1ba33cce0a57be0076e4859',
  dataDogInternalClientToken: 'PS7-Agent-Iframe-browser',
  rumSssionSampleRate: 5,
  datadogProxyCheckerUrl: 'https://proxy.datadog.prod.aws.cloud.ihf:3844',
  ACTIONS_ALLOW_USE_UNSECURE_NODE_VERSION: true,
};
